module.exports={"Clear search":"Wyczyść zawartość wyszukiwania"};